import './registro.css';

const Registro = () => {
  return (
    <div className="iframe-registro">
      <h1>Regístrate</h1>
      <iframe
        title="registro"
        src="https://forms.office.com/Pages/ResponsePage.aspx?id=PTPrKun-zE6lChFwi8SscgaC4X80uQxGhplUhRMi3XZUQzczUjNFRTc4NkFOQldKNUVSWlJPSFM4Ry4u&embed=true"
        frameborder= "0"
        marginWidth= "0"
        marginHeight= "0">
      </iframe>
    </div>
  );
}
 
export default Registro;